import React from 'react';
import {Link, useSearchParams} from 'react-router-dom';
import AuthCard from './auth/AuthCard';
import {primaryButtonClass} from './formStyles';

const FALLBACK_MESSAGE = 'That link is invalid or has expired.';

/**
 * Where an unhandled Supabase auth-redirect failure lands — chiefly an already-used or expired
 * password-reset link. Supabase reports these by appending `error`/`error_description` to whatever
 * URL it redirects back to, which is the root landing page when a link's own `redirect_to` isn't
 * honoured (a recovery email built from the stock `{{ .ConfirmationURL }}` template can land here
 * instead of `/reset-password`). Before this page existed that error was silently dropped: the
 * landing page rendered right over it with nothing telling the visitor their link didn't work.
 *
 * `App.tsx` is what routes here — see its auth-redirect effect — for any path that doesn't already
 * read these params itself (`/login`, `/auth/confirm`, `/reset-password` all do).
 */
const AuthErrorContainer: React.FC = () => {
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message') || FALLBACK_MESSAGE;

  return (
    <AuthCard title="This link is invalid or has expired" subtitle={message}>
      <Link to="/" className={`mt-5 block w-full text-center ${primaryButtonClass}`}>
        Back to CensorMe
      </Link>
    </AuthCard>
  );
};

export default AuthErrorContainer;
